export default __webpack_public_path__ + "static/media/illustration-algocare-m@3x.d7978bda.png";